module.exports = "/images/img-1.jpg?556af5dfce8939fa3315dc31ec3243c2";